import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { cartSelector } from '../../../modules/selectors/standort/session/cart';
import PayPalCheckout from '../Checkout/PayPalCheckout';
import CheckoutProducts from '../Checkout/CheckoutComponents/CheckoutProducts';
import { bindActionCreators } from 'redux';
import CheckoutTotalPrice from '../Checkout/CheckoutComponents/CheckoutTotalPrice';
import InitiateCheckoutButton from '../../components/CartComponents/InitiateChekoutButton/InitiateCheckoutButton';
import ContinueShoppingButton from '../../components/CartComponents/ContinueShoppingButton/ContinueShoppingButton';
import { frontloadConnect } from 'react-frontload';
import { deleteCoupon, fetchCartIfNeeded, removeProduct, resetPaypalOneClick, updateItem, validateCartBeforeCheckout } from '../../../modules/actions/standort/session/cart';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { userSelector } from '../../../modules/selectors/auth';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { showCouponInputSelector } from '../../../modules/selectors/standort/theme';
import loadable from '@loadable/component';
import { PayPalMessages } from '@paypal/react-paypal-js';

const CouponInput = loadable(() => import('./components/CouponInput'));

class Cart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            GAUrlAfterShop: '',
            cartError: false,
            legalTypes: ['online-kauf', 'reservierung'],
            AppointmentProducts: [],
            ShippingProducts: [],
        };
        this.getProductsByLegalTypes = this.getProductsByLegalTypes.bind(this);
        this.initiateCheckout = this.initiateCheckout.bind(this);
        this.continueShopping = this.continueShopping.bind(this);
    }

    componentDidMount() {
        this.getProductsByLegalTypes();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cart !== this.props.cart) {
            this.getProductsByLegalTypes();
        }
    }

    async initiateCheckout(type) {
        const isValid = await this.props.validateCartBeforeCheckout();
        if (!isValid) {
           /*  window.UIkit.notification('Ein Artikel im Warenkorb ist nicht mehr verfügbar. Bitte überprüfen Sie Ihren Warenkorb.', {
                status: 'danger',
                pos: 'top-right',
            }); */
            return;
        }

        const { cart } = this.props;
        const onlineKauf = _.get(cart, 'stats.onlineKauf');
        if (
            onlineKauf.numOfPos > 0 &&
            (onlineKauf.grossProducts <= 0 || isNaN(onlineKauf.grossProducts) || onlineKauf.grossProducts === null)
        ) {
            this.setState({ cartError: true });
            if (typeof window !== 'undefined') {
                window.UIkit.notification('Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Eingaben.', {
                    status: 'danger',
                    pos: 'top-right',
                });
            }
        } else {
            if (this.props.user) {
                this.props.history.push(`/initiateCheckout?type=${type}`);
            } else {
                this.props.history.push(`/login?context=checkout&type=${type}`);
            }
        }
    }

    getProductsByLegalTypes() {
        const { cart } = this.props;
        if (cart) {
            const { products } = cart;
            if (!_.isEmpty(products)) {
                const ShippingProducts = products.filter(
                    product => product.selectedLieferweg && product.selectedLieferweg.legalType === 'online-kauf'
                );
                const AppointmentProducts = products.filter(
                    product => product.selectedLieferweg && product.selectedLieferweg.legalType === 'reservierung'
                );
                this.setState({ ShippingProducts: ShippingProducts, AppointmentProducts: AppointmentProducts });
            }
        }
    }

    continueShopping() {
        window.history.back();
    }

    render() {
        const { markenStandort, cart, standortUrl, history, user } = this.props;
        const { legalTypes, ShippingProducts, AppointmentProducts } = this.state;
        
        return (
            <>
                {_.isEmpty(cart?.products) ? (
                    <div className="uk-placeholder">Keine Produkte im Warenkorb</div>
                ) : (
                    <div className="cart_wrapper">
                        <h1>Warenkorb</h1>
                        <ContinueShoppingButton continueShopping={this.continueShopping} />
                        {legalTypes.map((legalType, index) => {
                            if (
                                (legalType === 'online-kauf' && ShippingProducts.length) ||
                                (legalType !== 'online-kauf' && AppointmentProducts.length)
                            )
                                return (
                                    <div key={index}>
                                        <h2 className="uk-margin-top">
                                            {' '}
                                            Ihre {legalType === 'online-kauf' ? 'Online Bestellung' : 'Reservierung'}{' '}
                                        </h2>
                                        <CheckoutProducts
                                            legalType={legalType}
                                            products={legalType === 'online-kauf' ? ShippingProducts : AppointmentProducts}
                                            markenStandort={markenStandort}
                                            type="cart"
                                            standortUrl={standortUrl}
                                            removeProduct={this.props.removeProduct}
                                            updateItem={this.props.updateItem}
                                        />
                                        {this.props.showCouponInput && !cart?.coupon && legalType === 'online-kauf' && <CouponInput />}
                                        <CheckoutTotalPrice
                                            cart={cart}
                                            type={legalType === 'online-kauf' ? 'onlineKauf' : 'reservierung'}
                                            standortUrl={standortUrl}
                                            deleteCoupon={this.props.deleteCoupon}
                                        />
                                        <InitiateCheckoutButton
                                            cart={cart}
                                            legalType={legalType}
                                            initiateCheckout={this.initiateCheckout}
                                        />
                                        {legalType === 'online-kauf' && markenStandort.paypalClientId && (
                                            <>
                                                <PayPalCheckout
                                                    history={history}
                                                    standortUrl={standortUrl}
                                                    cart={cart}
                                                    markenStandort={markenStandort}
                                                    products={ShippingProducts}
                                                    existingUser={user}
                                                    validateCartBeforeCheckout={this.props.validateCartBeforeCheckout}
                                                />
                                                {markenStandort?.paypalPayLaterMessages &&
                                                    <div className='uk-padding-small uk-padding-remove-left uk-flex uk-flex-center'>
                                                        <PayPalMessages style={{text:{align:'center'}}} forceReRender={[cart]} amount={cart.grossTotal} currency='EUR' placement='cart' />
                                                    </div>
                                                }
                                            </>
                                        )}
                                    </div>
                                );
                            else return null;
                        })}
                        <div className="uk-flex uk-flex-center">
                            <ContinueShoppingButton continueShopping={this.continueShopping} />
                        </div>
                    </div>
                )}
            </>
        );
    }
}

const frontload = async props => {
    await Promise.all([props.fetchCartIfNeeded(), props.resetPaypalOneClick()]);
};

const mapStateToProps = state => ({
    standortUrl: standortUrlSelector(state),
    user: userSelector(state),
    markenStandort: markenStandortSelector(state),
    cart: cartSelector(state),
    showCouponInput: showCouponInputSelector(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({ removeProduct, updateItem, deleteCoupon, fetchCartIfNeeded, resetPaypalOneClick, validateCartBeforeCheckout }, dispatch);

export default withStandortRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        frontloadConnect(frontload, {
            onUpdate: true,
            // The cart cannot be rendered on the server, since it depends on sessionId.
            // This would result in a (cached) empty cart.
            noServerRender: true,
        })(Cart)
    )
);
